import React, { useState } from 'react';

const UpdateOrderEditable = () => {
  const [items, setItems] = useState([
    { id: 1, name: 'Ice Cream', quantity: 1, price: 25.99, served: true },
    { id: 2, name: 'French Fries', quantity: 2, price: 1.00, served: false },
  ]);

  const subtotal = items.reduce((sum, item) => sum + item.price * item.quantity, 0);

  return (
    <div className=" mx-auto bg-white p-4 rounded-lg relative h-screen overflow-scroll">
      <h2 className="text-xl font-semibold mb-4 text-center">Update Order</h2>

      {/* Order Info */}
      <div className="bg-gray-100 p-3 rounded-md mb-4 text-sm">
        <p><strong>#000000</strong> - Balasundar</p>
        <p className="text-gray-500">+91 9538488452</p>
        <p className="text-gray-500">05 May 2024 - 09:25PM</p>
        <div className="flex flex-wrap gap-2 mt-2 text-xs">
          <span className="bg-yellow-100 text-yellow-800 px-2 py-1 rounded">Payment Pending</span>
          <span className="bg-orange-100 text-orange-800 px-2 py-1 rounded">Preparing</span>
          <span className="bg-pink-100 text-pink-800 px-2 py-1 rounded">Item: 1</span>
        </div>
      </div>

      {/* Item Summary */}
      <h3 className="text-md font-semibold mb-2">Item Summary</h3>
      <table className="w-full text-sm mb-4">
        <thead>
          <tr className="text-left border-b">
            <th></th>
            <th>Item Name</th>
            <th>Status</th>
            <th>Qty</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          {items.map(item => (
            <tr key={item.id} className="border-b">
              <td>
                <input type="checkbox" className="" />
              </td>
              <td>{item.name}</td>
              <td>
                <span className="text-white bg-purple-600 px-2 py-0.5 rounded text-xs">Served</span>
              </td>
              <td>{item.quantity}</td>
              <td>${(item.quantity * item.price).toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Totals */}
      <div className="text-sm text-right">
        <p>Sub Total: <strong>${subtotal.toFixed(2)}</strong></p>
        <p>Tax: <strong>$0.00</strong></p>
        <p className="font-bold text-md">Grand Total: ${subtotal.toFixed(2)}</p>
      </div>

      {/* Action Buttons */}
      <div className="flex justify-between mt-6">
        <button className="bg-purple-600 text-white px-4 py-2 rounded-md w-1/2 mr-2">Served</button>
        <button className="bg-green-600 text-white px-4 py-2 rounded-md w-1/2 ml-2">Fulfilled</button>
      </div>


     <div className="absolute bottom-12 w-full flex justify-center px-4 md:px-12">
  <button className="w-full text-center bg-primary text-white py-2 px-4 rounded-md">
    Add Item
  </button>
</div>

    </div>
  );
};

export default UpdateOrderEditable;
